/**
 * @generated SignedSource<<dcf336bd2b044e1b2a4fb4df353dc9ba>>
 * @relayHash f79e033ba0f23d056871464a56ac3303
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 350cfddee0965a06c2afb7bfc47f4d79265dd4e21f7e5e00c4310e54daf9bf07

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SoftwareOnboardingPageGupsQuery } from './SoftwareOnboardingPageGupsQuery.graphql';

const node: PreloadableConcreteRequest<SoftwareOnboardingPageGupsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "350cfddee0965a06c2afb7bfc47f4d79265dd4e21f7e5e00c4310e54daf9bf07",
    "metadata": {},
    "name": "SoftwareOnboardingPageGupsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
